import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import * as qs from 'qs';
import { Provider } from 'react-redux';

import store from './store';
import PointOfSale from './PointOfSalesContainer';
import './Responsiviness.css';
import './general.css';

const { REACT_APP_NODE_ENV } = process.env;

if (REACT_APP_NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://7578a181bd5f4aee984d9e3aa2a02f6a@sentry.olx.com.br/2',
    environment: REACT_APP_NODE_ENV,
    release: '3.24.2',
  });
}

const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });

ReactDOM.render(
  <Provider store={store}>
    <PointOfSale {...params} />
  </Provider>,
  document.getElementById('root'),
);
